<template>
  <div>
    <base-header class="pb-6" type="primary">
      <breadcrumb-header :items="breadcrumb"></breadcrumb-header>
    </base-header>

    <div class="container-fluid mt--6">
      <table-navigation :table-title="tableTitle"
                        :table-buttons="tableButtons"
                        :table-columns="tableColumns"
                        :table-data="tableData"
                        :router-view="routerView"
                        :connection-error="connectionError"
                        :pagination="pagination"
                        :filter-options="filterOptions"
                        @page="changePage"
      >
      </table-navigation>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import TableNavigation from "@/views/Store/Tables/TableNavigation";
import BreadcrumbHeader from "@/views/Store/Layout/BreadcrumbHeader";

const {mapState, mapActions} = createNamespacedHelpers('ProductPropertyListModule')

export default {
  name: 'ProductPropertyList',
  components: {
    BreadcrumbHeader,
    TableNavigation,
  },
  data() {
    return {
      tableTitle: 'Lista atrybutów produktu',
      routerView: 'product-property-view',
      tableButtons: [
        {
          label: 'Dodaj atrybut',
          icon: 'fas fa-edit',
          link: 'product-property-add',
        },
      ],
      tableColumns: [
        {
          prop: 'name',
          label: 'Nazwa',
          minWidth: 150,
          sortable: true,
          link: true,
        },
        {
          prop: 'code',
          label: 'Kod',
          minWidth: 120,
          sortable: true,
        },
      ],
      filterOptions: [
        {field: 'name', label: 'Nazwa'},
      ],
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.items,
      totalItems: state => state.totalItems,
      connectionError: state => state.apiConnectionErr
    }),
    breadcrumb() {
      return [
        {title: 'Sklep', link: {name: 'store'}},
        {title: 'Atrybuty'},
      ];
    },
    handleError() {
      return `Błąd ${this.connectionError.status} - ${this.$t[this.connectionError.status]}`
    },
    pagination() {
      return {
        totalItems: this.totalItems,
        perPage: 20,
        currentPage: parseInt(this.$route.params.pageNum || 1),
      };
    },
  },
  methods: {
    changePage(page) {
      this.$router.push({name: 'product-property-list', params: {pageNum: page}});
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('ProductPropertyListModule/resetItems', []);
    return next()
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit('ProductPropertyListModule/resetItems', []);
    this.$store.dispatch('ProductPropertyListModule/fetchList', {
      token: this.$store.state.Auth.token,
      page: to.params.pageNum || 1,
    });
    return next();
  },
  beforeCreate() {
    this.$store.dispatch('ProductPropertyListModule/fetchList', {
      token: this.$store.state.Auth.token,
      page: this.$route.params.pageNum || 1,
    });
  },
};
</script>
